import { Container, } from '@mui/material';
import { dataConstants } from '../../../src/constants';
import getPageMetaTags from '../../../lib/meta/_getMetaTags';
import FundList from '../../../src/components/Browse/FundList';

export default function BrowseStocks({ themeMode, funds_data }) {
  return (
    <>
      <Container maxWidth="xl">
        <FundList fundData={funds_data} />
      </Container>
    </>
  )
}

export async function getStaticProps() {
  const funds_data = require('../../../public/assets/search/funds.json');
  const meta_tags = (await getPageMetaTags('/blogs', false)) || {}
  const { getMetaTags } = meta_tags || {}

  return {
    props: {
      meta_tags: getMetaTags?.tags || null,
      funds_data
    },
    revalidate: dataConstants.REVALIDATE_IN.SEVEN_DAYS,
    // notFound: process.env.NODE_ENV !== 'production' ? false : true,
  }
}
